import { Box, Popover } from '@mui/material';
import { useImperativeHandle, useState, forwardRef } from 'react';
import { getEmojiTypesRows } from '../utils/getEmojisRows';
import { getEmojiForReaction } from '../utils/getEmojiForReaction';
import { ReactionType } from '../../../../generated/graphql';

export type AddReactionPopoverHandles = {
  openMenu: (event: React.MouseEvent<HTMLDivElement>) => void;
};

type AddReactionPopoverProps = {
  onReactionPress: (reactionType: ReactionType) => void;
};

const rows = getEmojiTypesRows();

export const AddReactionPopover = forwardRef(
  (props: AddReactionPopoverProps, ref) => {
    const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLButtonElement | null>(
      null,
    );

    useImperativeHandle(ref, () => ({ openMenu }));

    const closeMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setMenuAnchorEl(null);
    };

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setMenuAnchorEl(event.currentTarget);
    };

    return (
      <Popover
        open={!!menuAnchorEl}
        onClose={closeMenu}
        anchorEl={menuAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '6px',
            padding: '20px',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {rows.map((row, index) => (
              <Box
                key={`row-${index}`}
                sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
              >
                {row.map((emojiType) => (
                  <Box
                    className={`bg-primary-150`}
                    key={`emoji-${emojiType}`}
                    sx={{
                      fontSize: '20px',
                      width: '40px',
                      height: '40px',
                      borderRadius: '20px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      lineHeight: '40px',
                      textAlign: 'center',
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      props.onReactionPress(emojiType);
                    }}
                  >
                    {getEmojiForReaction(emojiType)}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      </Popover>
    );
  },
);
